<template>
  <div>
    <el-form :model="dataForm" label-width="120px" ref="dataForm" label-position="right">
      <el-form-item label="是否营业:"  style="margin-top:30px">
         <el-switch v-model="dataForm.business" style="margin-top:8px" @change="changeOnOff"></el-switch>
      </el-form-item>
      <el-form-item label="营业时间:" style="margin-top:80px">
        <el-time-picker
          v-model="dataForm.onTime"
          placeholder="营业时间"
          value-format="HH:mm"
          format="HH:mm"
        ></el-time-picker>
      </el-form-item>
      <el-form-item label="歇业时间:">
        <el-time-picker
          v-model="dataForm.offTime"
          placeholder="歇业时间"
          value-format="HH:mm"
          format="HH:mm"
        ></el-time-picker>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-button style="margin-left:80px;width:200px" type="primary" @click.native="settingTime">设定</el-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data(){
    return{
      dataForm:{
        business:true,
        onTime:'',
        offTime:"",
      },
      timer:null,
    }
  },
  methods:{
    //设定时间
    settingTime(){
      if(this.dataForm.onTime == this.dataForm.offTime){
        this.$message({message:'营业时间和歇业时间不能相同',type:"error"})
      }else if(this.dataForm.onTime > this.dataForm.offTime){
        this.$message({message:'营业时间不得晚于歇业时间',type:"error"})
      }else{
        let param =this.dataForm
        this.$postJson('uac/merchant/saveTime',param).then(res =>{
          if(res.code ==200){
            this.$message({message:res.message,type:'success'})
          }else{
            this.$message({message:res.message,type:'error'})
          }
        })
      }
    },

    //查询时间和是否营业
    getList(){
      return this.$postForm('uac/merchant/selctIsTime').then(res =>{
          this.dataForm.business =  res.result.business
        if(res.code ==200){
          this.dataForm.onTime = res.result.onTime
          this.dataForm.offTime = res.result.offTime
        }else{
          this.$message({message:res.message,type:'error'})
          return true
        }
      })
      // 返回getList的结果
    },

    //开关
    changeOnOff(){
      if(!this.dataForm.business){
        //关店
        this.$postForm('uac/merchant/merchantOff').then(res =>{
          if(res.code ==200){
            this.getList()
            this.$message({message:res.message,type:'success'})
          }else{
            this.getList().then(result => {
              !result && this.$message({message:res.message,type:'error'})
            })
          }
        })
      }else{
         //开店
        this.$postForm('uac/merchant/merchantOn').then(res =>{
          if(res.code ==200){
            this.getList()
            this.$message({message:res.message,type:'success'})
          }else{
            this.getList().then(result => {
              !result && this.$message({message:res.message,type:'error'})
            })
            // 若getList提示错误，则不继续提示错误
          }
        })
      }
    },
    
  },
  mounted(){
     this.getList()
  }
}
</script>
<style lang="scss" scoped>

</style>